module.exports = __webpack_public_path__ + "static/media/globe.192789c4.png";